/**
 * The names the copy screen and its words share. Kept free of imports, so the dictionary
 * (`i18n/he.ts`) can use them without pulling the screen's helpers in.
 */

/** What one row says about its copy (finer than the filters: "ready" is approved or edited). */
export type CopyRowState =
  'IN_PROGRESS' | 'FAILED' | 'WITHOUT_COPY' | 'GENERATED' | 'APPROVED' | 'EDITED';

/** The four texts of a product's copy, in the order the screen shows them. */
export const COPY_FIELDS = ['title', 'description', 'seoTitle', 'seoDescription'] as const;
export type CopyField = (typeof COPY_FIELDS)[number];
